<!--
================================================
Un composant pour créer/modifier un client

Url d'accès :
http://localhost:8080/fr/cronocloud-inc/clients


LIMITATION DU COMPOSANT :
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <!--    <div id="ModalClientManagementComp">-->
    <!--        {{'Hello ! :) I am ' + $options.name}}-->
    <!--    </div>-->

    <div class="modal" id="ModalClientManagementComp" v-on:keyup.esc="hideModal()" v-bind:class="{ 'is-active': isVisible,'darkMode':themeToDisplay=='dark'  }">
        <!--ajouter la classe is-active sur.modal pour l'afficher-->
        <div class="modal-background"></div>
        <div class="modal-card" >
            <header class="modal-card-head">
                <font-awesome-icon :icon="['fas', 'user-tie']" class="icon"/>

                <p class="modal-card-title has-text-left">
                    <span v-if="mode== 'creation'">{{$t('CréerUnNouveauClient')}}</span>
                    <span v-if="mode== 'edition'">{{$t('ModifierUnClient')}}</span>

                </p>
                <button v-on:click="hideModal()" id="closeModalClientManagement" class="delete" aria-label="close"></button>
            </header>
            <section class="modal-card-body">


                <!--                v-on:submit.prevent évite un comportement de rechargement de la page (au lieu de soumission du form) @link https://forum.vuejs.org/t/modal-form-submit-always-reloads-page/1279-->
                <form action="" v-on:keyup.enter="validateBeforeSubmit"  v-on:submit.prevent>

                    <!--------CHAMP NAME----------------------------------->
                    <div class="field">
                        <label style="display: none" for="modalClientManagement_name">{{$t('NomDuClient')}}</label>
                        <input class="input clientName" type="text" v-bind:placeholder="$t('NomDuClient')"
                               v-focus
                               tabindex="0"
                               v-model="newClient.name"
                               v-validate="'required|max:80'"
                               data-vv-validate-on="change"
                               name="modalClientManagement_name"
                               id="modalClientManagement_name"
                               v-bind:class="{'is-loading':isSubmiting}"
                        >
                        <p class="help is-danger has-text-left" id="error_modalClientManagement_name">{{errors.first('modalClientManagement_name') }}</p>

                    </div>

                    <!--------CHAMP COLOR----------------------------------->
<!--                    <div class="field">-->
<!--                        <label class="label" for="modalClientManagement_color">{{$t('CouleurDuProjet')}}</label>-->
<!--                        <p class="help">{{$t('PermettraDitentifierVotreProjet')}}</p>-->

<!--&lt;!&ndash;                        <client-color-selector-comp&ndash;&gt;-->
<!--&lt;!&ndash;                                v-bind:mode="mode"&ndash;&gt;-->
<!--&lt;!&ndash;                        ></client-color-selector-comp>&ndash;&gt;-->
<!--                        <input type="hidden" id="modalClientManagement_color" v-model="newClient.color" name="modalClientManagement_color" v-validate="{required:true}">-->
<!--                        <p class="help is-danger has-text-left" id="error_modalClientManagement_color">{{errors.first('modalClientManagement_color') }}</p>-->

<!--                    </div>-->

                    <!--------------------------------------------------------------->
                    <div class="columns settingsZone">


                        <!--------CHAMP ARCHIVE----------------------------------->
                        <div class="column blocArchive" v-if="mode=='edition'">

                            <div class="field">
                                <label class="label" for="modalClientManagement_archive">{{$t('archivage')}}</label>

                                <input v-on:click="toggleArchive" id="modalClientManagement_archive" type="checkbox" name="modalClientManagement_archive" class="switch is-medium is-rounded" v-model="reversedIsArchivedComputed" checked="checked" v-bind:class="{'isArchived':newClient.isArchived}">
                                <label for="modalClientManagement_archive" class="archiveLabel">
                                    <!-- à afficher même vide sinon le switch n'est pas visible-->
                                    <span v-if="newClient.isArchived" class="indicator">
                                        <font-awesome-icon  class="icon" :icon="['fas', 'folder']" />
                                        {{$t('ClientArchivé')}}
                                    </span>
                                    <span v-else class="indicator">
                                        <font-awesome-icon  class="icon" :icon="['fas', 'user-tie']" />
                                        {{$t('ClientActif')}}
                                    </span>

                                </label>

                                <span class="help">
                                     <span v-if="newClient.isArchived">{{$t('CeClientEstArchivé')}}</span>
                                    <span v-else>{{$t('CeClientEstActif')}}</span>
                                </span>

                            </div>
                        </div>

                    </div>

                    <!--//////////////////////////////////// -->

                </form>

            </section>
            <footer class="modal-card-foot">
                <a v-on:click="hideModal()" class="button is-text cancelLink">{{$t("annuler")}}</a>
                <a v-on:click="validateBeforeSubmit()" v-bind:class="{'is-loading':isSubmiting}" v-bind:disabled="isSubmiting" class="button is-primary validBtn " id="submitModalClientManagement" >{{$t("valider")}}</a>
            </footer>

        </div>

    </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../mixins/SentryMixin.js";
    // import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import _ from 'lodash'
    import TrackingMixin from "@/mixins/TrackingMixin";

    export default {
        name: 'ModalClientManagementComp', //utile dans vue dev tool
        mixins: [GlobalErrorNotification, SentryMixin, InterceptorMixin, TrackingMixin],

        directives: {
            /**
             * Permet de focuser un élément avec v-focus (requiert l'attribut "tabindex" sur la cible)
             * @link https://vuejs.org/v2/guide/custom-directive.html
             **/
            focus: {
                update: function (el) {
                    el.focus()
                }
            }
        },

        components: {},

        props: {
            client : Object, // un objet client à éditer, si vide alors le composant est en mode création, sinon en mode édition
        },
        data: function () {
            return {
                locale : this.$route.params.locale,
                mode: 'creation', // String le mode dans lequel on utilise la modale : 'creation/edition'
                isVisible: false, // bool | la visibilité de la modale
                isSubmiting: false,
                clientsOrg: [], // Array | la liste des clients de l'organization
                isLoadingClients: true, //bool vaut true si la


                // NOTE : GARDER  newClient SYNCHRO AVEC resetClient() !
                newClient: // L'objet du nouveau client à créer
                    {
                        name: null , // String | le nom du client
                        isArchived: false, // Bool si true le client est archivé
                    },

                // pour les composants où l'user est identifié ///////////////////////
                organizationSlug: this.$route.params.organization
                // userSlug: JSON.parse(this.$cookie.get('auth')).userSlug
                // componentIsReady : false, // indique quand le composant est prêt à être afficher
                // =================================================================
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                // user: state => state.user
                organization: state => state.organization,
                themeToDisplay: state => state.app.themeToDisplay
            }),

            //----------------------------------------------

            // other computed props :
            reversedIsArchivedComputed: {
              get: function () { return !this.newClient.isArchived;},
              set: function (newValue) {
                // this.reversedIsArchived = newValue
              }
            }

        },
        // watch: {
        //     // à chaque fois que la prop computed user change, cette fonction s'exécutera
        //     user: function () {
        //     }
        // },


        methods: {

            /*
            * Affiche la modale
            */
            showModal(){
                this.isVisible = true
            },

            /*
            * Masque la modale
            */
            hideModal(){
                this.isVisible = false
                this.isSubmiting=false

                this.resetClient()
            },

            /**
             * Définit toute les propriété de l'objet passé à null
             *
             * Cette sert lorsque l'on ferme la modal puis qu'on la ré-ouvre évite que les informations de l'ouverture précédente restent affichées.
             */
            resetClient(){
                this.newClient.isArchived = false
                this.newClient.name = null
            },

            /*
              Toggle la property isArchived
            */
            toggleArchive() {
                if (this.newClient.isArchived=== true) {
                    this.newClient.isArchived= false
                } else {
                    this.newClient.isArchived= true
                }
            },

            /**
             * Récupère les clients de l'organization
             **/
            LoadOrganizationClients(){

                let self = this;
                self.$http.get(
                    `organizations/${self.$auth.getOrganization()}/clients`,
                    {
                        params: {},
                        headers: {Authorization: self.$auth.header()}
                    }
                )
                    .then(function (response) {
                      self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur
                      self.clientsOrg = response.data
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                            self.logToSentry(self, error, 'error')

                            let errorCode = '0026a'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error fetching organization clients', 'fatal': false})

                            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error fetching organization clients"})
                            self.$sentry.captureMessage(`Error ${errorCode} > error fetching organization clients : ${error}`, 'error')

                        }
                    })
                    .then(function () {
                        self.isLoadingClients= false
                    })

            },


            /**
             * Valide le form avant soumission
             **/
            validateBeforeSubmit(){

                let self =this;
                this.$validator.validateAll().then((result) => {
                    if (result) { // si la validation. réussie
                        switch (self.mode) {
                            case  'creation':
                                self.sendCreateQuery()
                                break;
                            case 'edition':
                                self.sendEditQuery()
                                break;
                        }
                    }
                    else{ // si il y a des erreurs...
                        self.$store.commit('UpdateGlobalNotificationComp', {
                            'isVisible': true,
                            'color': 'is-danger',
                            'message': self.$t('leFormulaireContientDesErreurs')
                        });
                    }

                })
            }

            /**
             * Envoie la requête post de création d'un client
             * @return {Promise<{} | never>}
             */
            ,sendCreateQuery(){

                this.isSubmiting = true;

                let self = this
                return self.$http
                    .post(`/organizations/${self.organizationSlug}/clients`,
                        {

                            name: self.newClient.name,
                            isArchived: self.newClient.isArchived,
                        },
                        {headers: {Authorization: self.$auth.header()}}
                    )
                    .then(function (response) {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                        // on envoie un event pour dire au ClientSelectorComp de maj les clients
                        self.$root.$emit('new_client_added',response.data)

                        // on Définit le client qui sera sélectionné dans NewTaskComp
                        self.$root.$emit('client_selected',response.data)

                        self.hideModal()

                        // tracking
                      self.ga4GlobalEventTrack('Client created' , {})

                      self.$mixpanel.track("Client created", {"timerecord":response.data.slug});
                        return {}
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if(self.shouldBeIntercepted(error.response,self.$auth) === false){
                            self.logToSentry(self, error, 'error')

                            let errorCode = '0027'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error creating client', 'fatal': false})

                          self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error creating client"})
                            self.$sentry.captureMessage(`Error ${errorCode} > error creating client : ${error}`, 'error')
                        }
                    })
                    .then(function () {
                        self.isSubmiting = false;
                    })
            }

            /**
             * Envoie la requête patch de modification d'un client
             * @return {Promise<{} | never>}
             */
            ,sendEditQuery(){
                this.isSubmiting = true;

                let self = this
                return self.$http
                    .patch(`/organizations/${self.organizationSlug}/clients/${self.newClient.slug}`,
                         {
                            name: self.newClient.name,
                            isArchived: self.newClient.isArchived,
                        },
                        {headers: {Authorization: self.$auth.header()}}
                    )
                    .then(function (response) {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                      // on envoie un event pour dire au ClientListComp de maj les clients
                        self.$root.$emit('client_edited',response.data)

                        self.hideModal()

                        // tracking
                        self.$mixpanel.track("Client edited", {"timerecord":response.data.slug});
                        self.ga4GlobalEventTrack('Client edited' , {})

                        return {}
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if(self.shouldBeIntercepted(error.response,self.$auth) === false){
                            self.logToSentry(self, error, 'error')

                            let errorCode = '0028'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error editing client', 'fatal': false})

                          self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error editing client"})
                            self.$sentry.captureMessage(`Error ${errorCode} > error editing client : ${error}`, 'error')
                        }
                    })
                    .then(function () {
                        self.isSubmiting = false;
                    })
            }

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {
            // this.logToSentry(this, 'push a log to sentry :)', 'info')

            // on charge la liste de clients de l'organization
            this.LoadOrganizationClients()

            /*
             * Event show_modal_client_management, déclenche l'affichage de la modale
             * @param mode String (edition/creation)
             * @param client L'objet client (dans le cas du mode edition)
             */
            this.$root.$on('show_modal_client_management', (mode, client) => {


                this.mode = mode // on définit le mode de la modale

                switch (mode) {
                    // mode creation pré-remplissage du nom du client
                    case  'creation': {

                        if (client != null) {
                            this.newClient.name = client.name
                        }
                        break;
                    }
                    // mode edition : hydratation de la modal avec le client à modifier
                    case 'edition': {

                        // ici on clone l'objet client (sinon altère le client dans le ClientListComp)
                        let clone = _.clone(client)
                        this.newClient = clone

                    }
                        break;
                }

                this.showModal()
            })


        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/

    #ModalClientManagementComp {

      .modal-card-head .icon {
        margin-right: 0.5rem;
        color: $brandFourth;
      }

      .clientName{
        &::placeholder{
        }
      }

      .field {
        margin-bottom: 1.5rem;
      }

      .label {
        margin-bottom: 0;
      }

      .help {
        margin-top: 0;
      }

      .settingsZone {

        label {
          margin-bottom: 0.5rem;
          /*text-transform: low;*/
          .indicator {
            font-size: 1rem;
          }
        }
      }

      .blocPrivacy {

      }

      .blocArchive {

      }

      /////////////////////////////////////////
      // DARK THEME ///////////////////////////
      &.darkMode {

        .clientName{
          &::placeholder{
            color: lighten($darkBg,10%);
          }
        }

        label {
          .indicator {
            color: $darkLightBlue !important;
          }
        }
      }
    }

</style>
